import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getSubgroup = (searchKey, isSearchToChildGroups, parentGroupId) => {
  cancelToken = getAxiosCancelToken(cancelToken);

  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.GROUP_MANAGEMENT.GET_SUBGROUP(
      searchKey,
      isSearchToChildGroups,
      parentGroupId
    ),
    "",
    cancelToken
  );
};

export default getSubgroup;
